import { HttpClient } from '@angular/common/http';
import { computed, inject, Injectable, resource } from '@angular/core';
import { firstValueFrom } from 'rxjs';

export interface SelectorProvider {
  key: string;
  displayName: string;
  description?: string;
}

@Injectable({
  providedIn: 'root'
})
export class SelectorProviderService {
  private readonly _http = inject(HttpClient);

  private readonly _providersResource = resource({
    loader: async () =>
      firstValueFrom(this._http.get<SelectorProvider[]>('/api/core/SelectorProvider/GetProviders'))
  });

  public readonly providers = computed(() => this._providersResource.value() ?? []);
  public readonly isLoading = computed(() => this._providersResource.isLoading());
  public readonly error = computed(() => this._providersResource.error());

  public reload(): void {
    this._providersResource.reload();
  }
}
